<template>
  <mdb-container id="Service">
    <section class="my-5">
      <h2 class="h1-responsive font-weight-bold text-center my-5">Und der Transport nach Deutschland ...?!</h2>
      <p class="lead grey-text w-responsive text-center mx-auto mb-5">Das übernehmen wir gerne für Sie. Wir transportieren Ihr Fahrzeug aus jedem Winkel der USA, mit anschließender Verschiffung nach Bremerhaven oder Rotterdam, als auch in alle anderen europäischen Häfen. Als kompetenter Partner mit langjähriger Erfahrung, kümmern wir uns um die komplette Abwicklung und sogar darüber hinaus ...<br /> 
<p style="text-align: center;">Wir bieten Ihnen vollen Service mit Preisgarantie!</p>
<p style="text-align: center;"><br />Fordern Sie v&ouml;llig unverbindlich unsere Preisliste an und &uuml;berzeugen Sie sich von unserem Angebot.<br /> <strong><em>&bdquo;Kompetenz und Fairness in Preis und Leistung&ldquo;</em></strong></p>
<p style="text-align: center;">... damit Sie sich voll und ganz auf den Kauf Ihres Traumfahrzeuges konzentrieren k&ouml;nnen.</p>
<br >
      <mdb-row>
        <mdb-col lg="5" class="text-center text-lg-left">
          <img class="img-fluid" src="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2FSEDAN3.png?alt=media&token=95080ad0-6126-4bac-aa1f-08516de8c686" alt="car" />
        </mdb-col>
        <mdb-col lg="7">
          <mdb-row class="mb-3">
            <mdb-col size="1">
              <mdb-icon icon="share" size="lg" class="indigo-text"/>
            </mdb-col>
            <mdb-col xl="10" md="11" size="10">
              <h5 class="font-weight-bold mb-3">Preisgarantie:</h5>
              <p class="grey-text">Wir bieten Ihnen vollen Service mit Preisgarantie. Unser Angebot umfasst einen garantierten Kostenplan für den Fahrzeugtransport innerhalb der USA* mit anschließender Verschiffung nach Bremerhaven bzw. Rotterdam.</p>
            </mdb-col>
          </mdb-row>
          <mdb-row class="mb-3">
            <mdb-col size="1">
              <mdb-icon icon="share" size="lg" class="indigo-text"/>
            </mdb-col>
            <mdb-col xl="10" md="11" size="10">
              <h5 class="font-weight-bold mb-3">Importabwicklung:</h5>
              <p class="grey-text">
Die komplette Import- und Zollabwicklung inkl. aller Einfuhrformalitäten übernimmt unser langjähriger und kompetenter Partner für Sie.</p>
            </mdb-col>
          </mdb-row>
          <mdb-row class="mb-3">
            <mdb-col size="1">
              <mdb-icon icon="share" size="lg" class="indigo-text"/>
            </mdb-col>
            <mdb-col xl="10" md="11" size="10">
              <h5 class="font-weight-bold mb-3">Extra-Service:</h5>
              <p class="grey-text">Gerne sind wir Ihnen auch bei Ihrer Fahrzeugsuche behilflich. Unser Extra-Service umfasst: Fahrzeugsuche, Kontaktaufnahme, Vermittlung, Informationsanfrage, Begutachtung, Preisverhandlung, Kostenkalkulation, Zahlungsabwicklung, Transport, Verschiffung, Importabwicklung, Anlieferung …</p>
            </mdb-col>
          </mdb-row>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
  import { mdbContainer, mdbRow, mdbCol, mdbIcon, mdbBtn } from 'mdbvue';
  export default {
    name: 'features',
    components: {
      mdbContainer,
      mdbRow,
      mdbCol,
      mdbIcon,
      mdbBtn
    }
  }
</script>